"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionPingDTO = exports.SessionStartDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const dto_factory_1 = require("../types/dto-factory");
let SessionStartDTO = class SessionStartDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Application session id, if available'),
    __metadata("design:type", String)
], SessionStartDTO.prototype, "sessionId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.MaybeUrl)(),
    (0, decorators_1.Describe)('Context in which session started (URL, game screen)'),
    __metadata("design:type", String)
], SessionStartDTO.prototype, "context", void 0);
SessionStartDTO = __decorate([
    (0, decorators_1.Describe)('An application session started')
], SessionStartDTO);
exports.SessionStartDTO = SessionStartDTO;
let SessionPingDTO = class SessionPingDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Application session id, if available'),
    __metadata("design:type", String)
], SessionPingDTO.prototype, "sessionId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.MaybeUrl)(),
    (0, decorators_1.Describe)('Context in which session pinged (URL, game screen)'),
    __metadata("design:type", String)
], SessionPingDTO.prototype, "context", void 0);
SessionPingDTO = __decorate([
    (0, decorators_1.Describe)('An application wishes to check in'),
    (0, decorators_1.Warning)('Session should have been started with event prior to ping')
], SessionPingDTO);
exports.SessionPingDTO = SessionPingDTO;
